// ============================================================================
// LIBRARY REPOSITORY
// ARQUIVO: src/services/LibraryRepository.js
// RESPONSABILIDADE: CRUD de itens da biblioteca jurídica.
// Criado: Fase 6.3 — mover Firestore direto de LibraryManager.jsx para repositório.
// ============================================================================

import { collection, query, orderBy, limit, onSnapshot, doc, updateDoc, deleteDoc, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const APP_ID = FIREBASE_CONFIG?.projectId || 'portalrda-f312d';
const PATH = ['artifacts', APP_ID, 'public', 'data', 'library_items'];

export { serverTimestamp } from 'firebase/firestore';

/** Observa itens da biblioteca (onSnapshot). */
export function watchLibraryItems(onData) {
  const q = query(collection(db, ...PATH), orderBy('updated_at', 'desc'));
  return onSnapshot(q, (snap) => {
    onData(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  });
}

/** Busca itens da biblioteca (getDocs). */
export async function fetchLibraryItems() {
  const q = query(collection(db, ...PATH), orderBy('updated_at', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

/** Aprova item (status = PUBLISHED). */
export async function approveLibraryItem(itemId) {
  await updateDoc(doc(db, ...PATH, itemId), { status: 'PUBLISHED' });
}

/** Deleta item. */
export async function deleteLibraryItem(itemId) {
  await deleteDoc(doc(db, ...PATH, itemId));
}

/** Busca itens da biblioteca (ordem decrescente por updated_at). */
export async function getLibraryItems(limitCount = 50) {
  const q = query(collection(db, ...PATH), orderBy('updated_at', 'desc'), limit(limitCount));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

/** Cria novo item. */
export async function createLibraryItem(data) {
  const created = await addDoc(collection(db, ...PATH), data);
  return created;
}

/** Atualiza item. */
export async function updateLibraryItem(itemId, data) {
  await updateDoc(doc(db, ...PATH, itemId), { ...data });
}
